import React from "react";
import { useState } from "react";
import Form from "react-bootstrap/Form";
import { Button, Modal } from "react-bootstrap";
import { putWithAuth } from "../../api/api";
import { API_URLS } from "../../api/apiConfig";
import { useNavigate } from "react-router-dom";

const ModalUpdateCategory = ({ onClose, category }) => {
  const navigate = useNavigate();
  const [showAlert, setIshowAlert] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [alertMessage, setShowAlertMessage] = useState("");

  const [updateCategory, setCategory] = useState(category);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    setCategory((prevCategory) => {
      const updateCategory = {
        ...prevCategory,
        [name]: type === "checkbox" ? !prevCategory[name] : value,
      };
      return updateCategory;
    });

    console.log(updateCategory);
  };

  const updateCard = async (e) => {
    const formData = new FormData();
    formData.append("data", JSON.stringify(updateCategory));
    try {
      setIsLoading(true);
      const response = await putWithAuth(
        API_URLS.EDIT_CATEGORY(category.id),
        updateCategory,
      );
      console.log("FormData", formData);
      if (response.message === "success") {
        setIsLoading(false);
        window.location.reload();
      } else if (response.message === "error") {
        setIsLoading(false);
        setIshowAlert(true);
        setShowAlertMessage(response.detail);
      } else {
        setIsLoading(false);
        setIshowAlert(true);
        setShowAlertMessage("Ha ocurrido un error");
      }
    } catch (error) {
      console.error("Error creating user admin:", error);
    }
  };

  const handleSave = async (e) => {
    e.preventDefault();

    try {
      updateCard();
    } catch (error) {
      console.error("Error creating user admin:", error);
    }
  };

  return (
    <>
      <Modal show={true} onHide={onClose} size="xl" centered>
        <Modal.Header closeButton>
          <Modal.Title>Editar Categoría</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form
            className="form fv-plugins-bootstrap5 fv-plugins-framework"
            data-select2-id="select2-data-kt_modal_create_api_key_form"
          >
            <div
              className="modal-body py-10 px-lg-17"
              data-select2-id="select2-data-108-9vb6"
            >
              <div
                className="scroll-y me-n7 pe-7"
                id="kt_modal_create_api_key_scroll"
                data-kt-scroll="true"
                data-kt-scroll-activate="{default: false, lg: true}"
                data-kt-scroll-max-height="auto"
                data-kt-scroll-dependencies="#kt_modal_create_api_key_header"
                data-kt-scroll-wrappers="#kt_modal_create_api_key_scroll"
                data-kt-scroll-offset="300px"
                data-select2-id="select2-data-kt_modal_create_api_key_scroll"
              >
                <div className="notice d-flex bg-light-warning rounded border-warning border border-dashed mb-10 p-6">
                  <i className="ki-outline ki-information fs-2tx text-warning me-4"></i>
                  <div className="d-flex flex-stack flex-grow-1 ">
                    <div className=" fw-semibold">
                      <h4 className="text-gray-900 fw-bold">Atención!</h4>
                      <div className="fs-6 text-gray-700 ">
                        Agregar o editar una categoría puede tener consecuencias
                        en el resultado final de limpiezas
                      </div>
                    </div>
                  </div>
                </div>
                {showAlert && (
                  <div className="alert alert-danger d-flex align-items-center p-5">
                    <i className="fa-solid fa-triangle-exclamation fs-1 text-danger me-4">
                      <span className="path1"></span>
                      <span className="path2"></span>
                    </i>
                    <div className="d-flex flex-column">
                      <span className="mb-1 text-danger">{alertMessage}</span>
                    </div>
                  </div>
                )}
                <div className="row g-9 mb-8">
                  <div className="col-md-6 fv-row fv-plugins-icon-container">
                    <label className="required fs-6 fw-semibold mb-2">
                      Nombre de la categoría
                    </label>
                    <input
                      type="text"
                      className="form-control form-control-solid"
                      placeholder="Nombre de la categoría"
                      name="name"
                      onChange={handleInputChange}
                      defaultValue={category.name}
                    />
                  </div>
                  <div className="col-md-6 fv-row fv-plugins-icon-container">
                    <label className="required fs-6 fw-semibold mb-2">
                      Código de la categoría en RR
                    </label>
                    <input
                      type="text"
                      className="form-control form-control-solid"
                      placeholder="Código de la habitación"
                      name="rr_code"
                      onChange={handleInputChange}
                      defaultValue={category.rr_code}
                    />
                  </div>
                </div>

                <div className="row g-9 mb-8">
                  <div className="col-md-6 fv-row fv-plugins-icon-container">
                    <label className="required fs-6 fw-semibold mb-2">
                      Tipo de categoría
                    </label>
                    <select
                      onChange={handleInputChange}
                      name="cat_type"
                      className="form-select"
                      aria-label="Default select example"
                    >
                      <option value="Habitación Doble">Habitación Doble</option>
                      <option value="Habitación Individual">
                        Habitación Individual
                      </option>
                      <option value="Habitación Triple">
                        Habitación Triple
                      </option>
                      <option value="Habitación Cuadruple">
                        Habitación Cuadruple
                      </option>
                    </select>
                  </div>
                  <div className="col-md-6 fv-row fv-plugins-icon-container">
                    <label className="required fs-6 fw-semibold mb-2">
                      Descripción
                    </label>
                    <input
                      type="text"
                      className="form-control form-control-solid"
                      placeholder="Deacripción de la categoría"
                      name="description"
                      onChange={handleInputChange}
                      defaultValue={category.description}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="modal-footer flex-center">
              <button
                type="reset"
                id="kt_modal_create_api_key_cancel"
                className="btn btn-light me-3"
              >
                Cancelar
              </button>
              <button
                type="submit"
                onClick={handleSave}
                className="btn btn-primary"
                data-kt-indicator={`${isLoading ? "on" : "off"}`}
              >
                <span className="indicator-label">Editar categoría</span>
                <span className="indicator-progress">
                  Guardando ...{" "}
                  <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                </span>
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ModalUpdateCategory;
